import HttpClient from '../../core/services/http-client';
import extractEventId from '../utils/helpers';
import { decoratePayloadSelectedTickets } from './decorator';
import { saveEventId } from '../services/storage';
import { BASE_ADD_TICKET_CODES_PATH, BASE_API_FORGOT_PASSWORD, BASE_API_PROVIDER, BASE_BANK_ACCOUNT_PATH, BASE_EVENTS_PATH,
    BASE_PUBLISH_TICKETS_PATH, BASE_SAVE_BANK_ACCOUNT_PATH, BASE_SAVE_SELL_PRICE_PATH, BASE_SELECT_TICKETS_PATH, BASE_TICKETS_PATH,
    BASE_UNSELECT_TICKET_PATH, BASE_VALIDATE_TICKET_CODES_PATH } from './config';
import { API_BASE_URL } from '../../cart/api/config';
import { SELL_STEP_2 } from '../constants/steps';

export const fetchEvents = () => HttpClient.execute(`${API_BASE_URL}${BASE_EVENTS_PATH}`, 'GET');
export const fetchTickets = (step, eventId) => HttpClient.execute(
    `${API_BASE_URL}${BASE_TICKETS_PATH}/${step}/${eventId}`,
    'GET',
);
export const saveSelectedTickets = async (tickets, goToNextStep, errorNotify) => {
    try {
        const payload = decoratePayloadSelectedTickets(tickets);
        const response = await doSaveSelectedTickets(extractEventId(), payload);
        const formattedResponse = await response.json();
        if (formattedResponse.status === 'success') {
            goToNextStep();
            return;
        }
        errorNotify();
    } catch (e) {
        errorNotify();
    }
};

export const addTicketCodes = async (goToNextStep, errorNotify) => {
    try {
        const response = await doAddTicketCodes();
        const formattedResponse = await response.json();
        if (formattedResponse.status === 'success') {
            saveEventId(formattedResponse.eventId);
            const ticketsResponse = await fetchTickets(SELL_STEP_2, formattedResponse.eventId);
            const formattedTicketsResponse = await ticketsResponse.json();
            if (formattedTicketsResponse.status === 'success') {
                const { tickets } = formattedTicketsResponse.data;
                const ticketsCodes = tickets.map((ticket) => ticket.code);
                const selectedTicketsResponse = await doSaveSelectedTickets(formattedResponse.eventId, ticketsCodes);
                const formattedSelectedTicketsResponse = await selectedTicketsResponse.json();
                if (formattedSelectedTicketsResponse.status === 'success') {
                    goToNextStep();
                    return;
                }
            }
        }
        errorNotify();
    } catch (e) {
        errorNotify();
    }
};

export const doSaveSelectedTickets = (eventId, payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_SELECT_TICKETS_PATH}/${eventId}`,
    'POST',
    {},
    payload,
);
export const doUnselectSellTicket = (eventId, code) => HttpClient.execute(
    `${API_BASE_URL}${BASE_UNSELECT_TICKET_PATH}/${eventId}/${code}`,
    'POST',
);

export const doSaveSellPriceTickets = (eventId, payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_SAVE_SELL_PRICE_PATH}/${eventId}`,
    'POST',
    {},
    payload,
);
export const fetchBankAccount = () => HttpClient.execute(`${API_BASE_URL}${BASE_BANK_ACCOUNT_PATH}`, 'GET');

export const doSaveBankAccount = (payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_SAVE_BANK_ACCOUNT_PATH}`,
    'POST',
    {},
    payload,
);
export const doPublishTickets = (eventId, payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_PUBLISH_TICKETS_PATH}/${eventId}`,
    'POST',
    {},
    payload,
);

export const doValidateTicketCodes = (payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_VALIDATE_TICKET_CODES_PATH}`,
    'POST',
    {},
    payload,
);

export const doAddTicketCodes = () => HttpClient.execute(
    `${API_BASE_URL}${BASE_ADD_TICKET_CODES_PATH}`,
    'POST',
    {},
);

export const forgotPassword = (payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_API_FORGOT_PASSWORD}`,
    'POST',
    {},
    payload,
);

export const doSaveProvider = (payload) => HttpClient.execute(
    `${API_BASE_URL}${BASE_API_PROVIDER}`,
    'POST',
    {},
    payload,
);
